export const dishCategoryListDataSelector = state => state.dish_category.listData;

export const dishCategoryStepSelector = state => state.dish_category.formStep;
export const dishCategoryCompletedStepsSelector = state => state.dish_category.completedSteps;

export const createOrUpdateInProcessSelector = state => state.dish_category.createOrUpdateInProcess;
export const createOrUpdateErrorsSelector = state => state.dish_category.errors;

export const deleteInProcessSelector = state => state.dish_category.deleteInProcess;
